import { StateService } from 'app/core/state.service';
import { OnInit, Component, ViewChild, ViewEncapsulation, Input } from '@angular/core';
import {MatPaginator, MatTableDataSource, MatSort, MatSortable, MatPaginatorIntl, MatSnackBar, MatDialog, SortDirection} from '@angular/material';
import {CheckitEvent, Registrant} from '../checkit.model';
import { Router } from "@angular/router";
import {AngularFirestore, AngularFirestoreCollection} from "angularfire2/firestore";
import {Observable} from 'rxjs/Observable';
import {merge} from 'rxjs/observable/merge';
import {catchError} from 'rxjs/operators/catchError';
import {map} from 'rxjs/operators/map';
import {startWith} from 'rxjs/operators/startWith';
import {switchMap} from 'rxjs/operators/switchMap';
import {Subject, Timestamp} from "rxjs";
import { AuthService } from "../../../core/auth.service";
import {AngularFirestoreDocument} from "angularfire2/firestore/document/document";

/**
 * Created by greg on 9/03/2018.
 */

@Component({
    selector: 'events-dashboard',
    styleUrls: [`events-dashboard.styl`],
    template: `
<div class="filter_content">
    <div class="col col1">
        <div class="search_content">
            <mat-icon>search</mat-icon>
            <input #searchInput (keyup)="applyFilter($event.target.value)"/>
            <mat-icon (click)="clearFilter(searchInput);">close</mat-icon>
        </div>
        <div class="category" [matMenuTriggerFor]="menu">
            <button mat-button [textContent]="state.checkit.events.search_category"></button>
            <mat-icon>arrow_drop_down</mat-icon>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="state.checkit.events.search_category = 'Events'">Events</button>
                <button mat-menu-item (click)="state.checkit.events.search_category = 'People'">People</button>
            </mat-menu>
        </div>
    </div>
    <div class="col col2">
        <div class="show_past">
            <mat-checkbox (click)="toggleViewClosedEvents()" color="primary" [(ngModel)]="state.user_settings['view_closed_events']">Show closed events</mat-checkbox>
        </div>
        <div class="pagination_content">
            <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[20, 50, 100, 1000]" ></mat-paginator>
        </div>
    </div>
</div>
<div class="load_panel" *ngIf="!areEvents">
    <div *ngIf="isLoadingResults"><mat-spinner></mat-spinner></div>
    <div *ngIf="!isLoadingResults" class="no_event">
        <mat-icon>event</mat-icon>
        <div>Your events live here, but it looks like you don’t have any!</div>
        <div class="link" (click)="requestNewEvent()">Create a new event</div>
    </div>
</div>
<alert-panel [(message)]="alert_message"></alert-panel>
<div class="events_content" [ngClass]="{hidden:!areEvents}" >
    <mat-table #table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
            <mat-cell *matCellDef="let evnt" class="event_title"> 
                <div class="active">Active</div>
                <div class="truncate">{{evnt.title}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef  mat-sort-header> Date </mat-header-cell>
            <mat-cell *matCellDef="let evnt"> {{evnt.date.toDate() | date:'EEEE d MMMM y'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="venue">
            <mat-header-cell *matHeaderCellDef  mat-sort-header> Location </mat-header-cell>
            <mat-cell *matCellDef="let evnt" class="truncate"> {{evnt.venue}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="attendance">
            <mat-header-cell *matHeaderCellDef  mat-sort-header class="col5"> Total checked in </mat-header-cell>
            <mat-cell *matCellDef="let evnt" class="col5">{{evnt.totalCheckin && evnt.totalCheckin > 0 ? evnt.totalCheckin : ''}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="days_til">
            <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
            <mat-cell *matCellDef="let evnt" class="status"> 
                <div class="event_status">{{isPastDate(evnt.date) ? (evnt.closed ? 'Closed' : 'Close Event') : formatDaysTil(evnt.date)}}</div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sort">
            <mat-header-cell *matHeaderCellDef >
                Sort by:
                <mat-select (change)="columnSort($event)">
                    <mat-option *ngFor="let opt of sort_options" [value]="opt.value" >{{opt.label}}</mat-option>
                </mat-select>
                <mat-icon class="small" (click)="sortDirection = sortDirection == 'asc' ? 'desc' : 'asc'">
                    {{sortDirection == 'asc' ? 'arrow_upward' : 'arrow_downward'}}</mat-icon>
            </mat-header-cell>
            <mat-cell *matCellDef="let evnt">
                <div class="row1">
                    <span class="name">{{evnt.title}}</span>
                    <span> &bull; {{evnt.venue}}</span>
                </div>
                <div class="row2">
                    <span>{{evnt.date.toDate() | date:'EEEE d MMMM y'}}</span>
                    <span>{{formatDaysTil(evnt.date) ? '('+formatDaysTil(evnt.date)+')' : ''}}</span>
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="smcol col2"></mat-header-cell>
            <mat-cell *matCellDef="let evnt"  class="right smcol col2">
                <div class="action_menu menu" [matMenuTriggerFor]="menu"><mat-icon class="menu">more_vert</mat-icon></div>
                <!--<i class="action_menu" [matMenuTriggerFor]="menu" (menuOpen)="eventMenuToggle(evnt,'open')" 
                (menuClosed)="eventMenuToggle(evnt,'closed')"-->
                   <!--class="material-icons menu-trigger text-grey hover:text-black cursor-pointer">more_vert</i> -->
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="selectEvent($event, evnt)">Manage...</button>
                        <button mat-menu-item (click)="editEvent(evnt)">Edit...</button>
                        <button mat-menu-item (click)="requestNewEvent(evnt)">Duplicate...</button>
                        <button mat-menu-item (click)="closeEvent(evnt)">Close...</button>
                        <button mat-menu-item (click)="deleteEvent(evnt)">Delete...</button>
                    </mat-menu></mat-cell>    
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row (click)="selectEvent($event, row)" [ngClass]="{past:getDaysTil(row.date) < 0, active:!row.closed, closed:row.closed, selected:row.selected}" 
                 *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

</div>`,
    encapsulation:ViewEncapsulation.None
})
export class EventsDashboardComponent implements OnInit {


    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    @Input() events: Observable<CheckitEvent[]> = Observable.of([]);
    @Input() message = '';

    now = Date.now();
    desktopColumns = ['title', 'date', 'venue', 'attendance','days_til','actions'];
    tabletColumns = ['sort', 'actions'];
    dataSource = new MatTableDataSource<CheckitEvent>();
    isLoadingResults = true;
    isRateLimitReached = false;
    areEvents = false;
    showClosed = true;
    $destroy: Subject<boolean> = new Subject();
    $clear: Subject<boolean> = new Subject();
    afs: AngularFirestore;
    alert_message = '';
    searched_columns = ['title','venue'];
    sort_options = [{label: 'Name', value: 'title'}, {label: 'Date', value: 'date'},
        {label: 'Location', value: 'venue'}, {label: 'Total checked in', value: 'attendance'}];
    displayedColumns = [];
    screenMode = '';
    _direction = 'desc';
    _active = 'date';
    appliedFilter = '';

    get sortDirection() {
        return this._direction;
    }
    set sortDirection(dir) {
        this._direction = dir;
        this.sort.active = this.sortActive;
        this.sort.direction = dir as SortDirection;
        this.dataSource.sort = this.sort;
    }
    get sortActive() {
        return this._active;
    }
    set sortActive(act) {
        this._active = act;
        this.sort.active = act;
        this.sort.direction = this.sortDirection as SortDirection;
        this.dataSource.sort = this.sort;
    }


    constructor(public state: StateService, private router: Router, private auth: AuthService, private pageIntl: MatPaginatorIntl) {
        this.afs = auth.afs;
        pageIntl.itemsPerPageLabel = 'Events per page:';
        this.dataSource = new MatTableDataSource<CheckitEvent>();
        this.showClosed = this.state.user_settings['view_closed_events'];
        console.log("this.state.user_settings ",this.state.user_settings)
        this.state.$eventsSet.takeUntil(this.$destroy).subscribe(() =>  this.setUpEventsTable() );
        this.state.screen.subscribe( mode => {
            if (this.screenMode != mode) {
                this.screenMode = mode;
                if (this.screenMode == 'tablet' || this.screenMode == 'mobile') {
                    this.displayedColumns = this.tabletColumns;
                } else {
                    this.displayedColumns = this.desktopColumns;
                }
            }
        });
        let mode = 'desktop';
        if (768 <= window.innerWidth && window.innerWidth <= 1280) {
            mode = 'tablet';
        } else if (window.innerWidth < 768) {
            mode = 'mobile';
        }
        this.state.screen.next(mode);
    }

    ngOnInit(){
        this.setUpEventsTable()
        // don't add the destroy code or it has to load each time you navigate around .takeUntil(this.$destroy)
        this.events.takeUntil(this.$destroy).subscribe(data => {
            console.log('init events loading to table');
            this.isLoadingResults = this.isRateLimitReached = false;
            this.areEvents = (data && data.length > 0);
            this.dataSource.data = data;
            this.togglePass();
            this.sortActive = 'date';
        });
        this.sort.sort(<MatSortable>{
                id: 'date',
                start: 'desc'
            }
        );

        setTimeout( () => {
            const filter = (data, key) => {
                let unfiltered = true;
                if(!this.state.user_settings['view_closed_events'] && data.closed) unfiltered = false;
                if(this.appliedFilter != ''){
                    let objstr = '';
                    for(let i = 0; i < this.searched_columns.length; i++){ objstr += data[this.searched_columns[i]].toLowerCase(); }
                    if(!objstr.includes(this.appliedFilter)) unfiltered = false;
                }
                return unfiltered;
            };
            this.dataSource.filterPredicate = filter.bind(this);
            this.dataSource.filter = 'init';
        }, 100);
    }
    requestNewEvent(starterEvent = null){
        if (starterEvent) {
            starterEvent = Object['assign']({}, starterEvent);
            starterEvent.is_duplicate = true;
            if(starterEvent.use_custom_id){
                starterEvent.retain_unique_ids = true;
            }
        }
        this.state.$requests.next({request: 'startNewEvent', event: starterEvent});
    }
    editEvent(editEvent){
        editEvent = Object['assign']({}, editEvent);
        this.state.$requests.next({request: 'editEvent', editEvent});
    }
    closeEvent(closeEvent){
        closeEvent = Object['assign']({}, closeEvent);
        this.state.$requests.next({request: 'closeEvent', closeEvent});
    }
    deleteEvent(evnt){
        const event = Object['assign']({}, evnt);
        this.state.$requests.next({request: 'deleteEvent', event});
    }
    eventMenuToggle(evnt,dir){
        evnt._is_menu_open = !evnt._is_menu_open;
    }

    setUpEventsTable(){
        console.log("setUpEventsTable");
        this.$clear.next(true);
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                startWith({}),
                switchMap((v) => {
                    this.isLoadingResults = true;
                    return this.events;
                }),
                map(data => {
                    // Flip flag to show that loading has finished.
                    this.isLoadingResults = false;
                    // this.isRateLimitReached = false;
                    if (data && data.length){
                        this.areEvents = true;
                    }else{
                        this.areEvents = false;
                    }
                    return data;
                }),
                catchError((e) => {
                    this.isLoadingResults = false;
                    this.isRateLimitReached = true;
                    return Observable.of([]);
                })
            )
            .takeUntil(this.$clear)
            // .subscribe(data => {
            //     this.dataSource.data = data;
            // })
    }
    columnSort(ev) {
        this.sortActive = ev.value;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.appliedFilter = filterValue;
        this.runFilter();
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    getDaysTil(date):number{
        if (!date) return 0;
        const d = date['toDate']().getTime() + (1000 * 60 * 60 * 24);
        const days = Math.floor((d - this.now) / 1000 / 60 / 60 / 24);
        return days;
    }

    isPastDate(date): boolean{
        if (!date) return true;
        return this.now > date['toDate']().getTime() + (1000 * 60 * 60 * 24);
    }

    formatDaysTil(date): string{
        if (!date) return '';
        const days = this.getDaysTil(date);
        return (days < 0) ? "" : (days == 0 ? 'Today' : days + ' days until event');
    }

    selectEvent($event, evnt){
        const classList = $event.target.classList;
        let skip = classList.contains('menu');
        if (classList.contains('event_status') && !evnt.closed && this.getDaysTil(evnt.date) < 0) {
            this.closeEvent(evnt);
            skip = true;
        }
        if (!skip) {
            if (/(^| )menu-trigger( |$)/i.test($event.target.className)) return;
            this.router.navigate(['checkit-event', evnt.eventId]);
        }
    }

    toggleViewClosedEvents(){
        const userDoc: AngularFirestoreDocument<any> = this.afs.doc(`users/${this.state.uid}`);
        userDoc.set({hide_closed_events:!!this.state.user_settings['view_closed_events']}, { merge: true }).then(_=>{
            //this.loading = false;
            //this.display_form = false;
            this.togglePass();
        })
    }

    togglePass() {
        this.dataSource.filter = 'toggle';
    }

    clearFilter(searchInput?){
        if(searchInput) searchInput.value = '';
        this.appliedFilter = ''
        this.dataSource.filter = 'clear';
    }

    runFilter(){
        this.dataSource.filter = 'search';
    }

    ngOnDestroy(){
        this.$clear.next(); this.$clear.complete();
        this.$destroy.next(); this.$destroy.complete();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/components/events-dashboard.component.ts